export default $axios => ({
  resource: 'moraine/plan'
})
